import React from 'react';
import './QualificationsSection.css';

const qualificationList = [
  {
    text: "Gesundheits- und Krankenpflegerin mit Schwerpunkt auf psychischer Gesundheit",
    images: [],
    unterpunkte: [
      { untertext: "Mehrjährige Erfahrung in der Behandlung von Depressionen, Angststörungen und Persönlichkeitsstörungen" },
      { untertext: "Kompetente Betreuung von Patienten in stationären und ambulanten psychiatrischen Einrichtungen" },
      { untertext: "Umfassende Expertise in der Begleitung von Menschen mit emotionalen und psychischen Herausforderungen" },
    ]
  },
  {
    text: "NLP Practitioner & NLP Master (Neurolinguistisches Programmieren)",
    images: [
      require('../assets/images/zert1.png'),
      require('../assets/images/zert5.png'),
    ],
    unterpunkte: [
      { untertext: "Zertifizierte NLP-Practitioner und NLP-Masterin mit fundierten Kenntnissen in der Veränderung von Denk- und Verhaltensmustern" },
      { untertext: "Unterstützung von Klientinnen bei der Steigerung von Selbstbewusstsein und der Überwindung limitierender Glaubenssätze" },
    ]
  },
  {
    text: "Hypnose - Coach",
    images: [require('../assets/images/zert4.png')],
    unterpunkte: [
      { untertext: "Erfahrene Hypnose-Coachin, spezialisiert auf Tiefenentspannung und Veränderung unbewusster Muster" },
      { untertext: "Erfolgreiche Anwendung von Hypnosetechniken zur Förderung emotionaler Heilung und persönlicher Transformation" },
    ]
  },
  {
    text: "Teilnehmerin an Tony Robbins 'Unleash the Power Within'",
    images: [],
    unterpunkte: [
      { untertext: "Inspirierende Erkenntnisse und praxisnahe Methoden zur persönlichen Weiterentwicklung durch die Teilnahme an einem der weltweit führenden Seminare für Selbstverwirklichung" }
    ]
  },
  {
    text: "Magnified Healing",
    images: [
      require('../assets/images/zert2.png'),
      require('../assets/images/zert3.png'),
    ],
    unterpunkte: [
      { untertext: "Ausbildung in Magnified Healing zur Wiederherstellung des energetischen Gleichgewichts und Aktivierung der Selbstheilungskräfte" },
      { untertext: "Anwendung energetischer Heilmethoden, um Blockaden zu lösen und ganzheitliches Wohlbefinden zu fördern" },
    ]
  },
];

const QualificationsSection = () => (
  <section className="qualifications-section">
    <div className="qualifications-content">
      <div className="qualifications-list-container">
        <h2 className="qualifications-title">Meine Qualifikationen</h2>
        <ul className="qualifications-list">
          {qualificationList.map((item, index) => (
            <li key={index} className="qualifications-list-item">
              <div className="qualification-flex-wrapper">
                <div className="qualification-text">
                  <span className="list-text">{item.text}</span>
                  {item.unterpunkte && (
                    <ul className="sub-list">
                      {item.unterpunkte.map((subItem, subIndex) => (
                        <li key={subIndex} className="sub-list-item">
                          <span className="sub-list-text">{subItem.untertext}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                {item.images.length > 0 && (
                  <div className="qualification-images">
                    {item.images.map((image, imgIndex) => (
                      <img key={imgIndex} src={image} alt="Zertifikat" className="qualification-icon" />
                    ))}
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="qualifications-image-container">
        <img src={require('../assets/images/chiaraTr5.png')} alt="Chiara" className="qualifications-image" />
        <p className="qualifications-quote">
          <em>„Es ist nicht die Last, die dich bricht,<br />sondern die Art, wie du sie trägst.“</em><br />
          <span className="quote-author">- Hans J. Ludwig</span>
        </p>
        <img src={require('../assets/images/logotrkl.png')} alt="Logo" className="qualifications-logo" />
      </div>
    </div>
  </section>
);

export default QualificationsSection;
